const routes = [
  {
    path: '/company', // 公司主页面
    name: 'company',
    component: () => import('@src/modules/companyManage/main'),
    redirect: '/company/index',
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'index', // 公司管理列表界面
        name: 'index',
        component: () => import('@src/modules/companyManage/view/company'),
        meta: {
          requireAuth: true,
          routerAlive: true
        }
      },
    ]
  },
]

export default routes
